export enum Gender {
  M = '1',
  F = '2'
}
export const GENDER_F = Gender.F
export const GENDER_M = Gender.M
export const GENDER_F_TEXT = '女'
export const GENDER_M_TEXT = '男'
